export const fontSizes = {
  xxSmall: 11,
  xSmall: 12,
  small: 13,
  medium: 14,
  large: 15,
  xLarge: 16,
  xxLarge: 18,
  xxxLarge: 20,
  caps: {
    xSmall: 9,
    small: 10,
    medium: 11,
    large: 12,
    xLarge: 14,
  },
} as const
